module.exports = __webpack_public_path__ + "img/sabaisland.d3516212.svg";